export enum CemocDriver {
    Productivity = 'Productivity',
    Technology = 'Technology',
    ScopeEfficiency = 'ScopeEfficiency',
    EstimateCorrection = 'EstimateCorrection',
    Regulatory = 'Regulatory',
    CurrencyImpact = 'CurrencyImpact',
    Weather = 'Weather',
    Other3rdParty = 'Other3rdParty',
    NewScope = 'NewScope',
    RemovedScope = 'RemovedScope',
    ScopeAcceleration = 'ScopeAcceleration',
    ScopeDeceleration = 'ScopeDeceleration',
}

export const CemocDriverLabels: Record<CemocDriver | string, string> = {
    Productivity: 'Productivity',
    Technology: 'Technology',
    ScopeEfficiency: 'Scope Efficiency',
    EstimateCorrection: 'Estimate Correction',
    Regulatory: 'Regulatory',
    CurrencyImpact: 'Currency Impact',
    Weather: 'Weather',
    Other3rdParty: 'Other 3rd Party',
    NewScope: 'New Scope',
    RemovedScope: 'Removed Scope',
    ScopeAcceleration: 'Scope Accelaration',
    ScopeDeceleration: 'Scope Deccelaration',
};
